import React, { useState } from 'react';
import axios from 'axios';

const NewsletterSignup = ({ variant }) => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState(null); 
    const MAX_RETRY = 3;
    const RETRY_DELAY = 2000;

    const subscribeNewsletter = async (retry = MAX_RETRY) => {
        try {
            const response = await axios.post('/api/newsletter-subscribe', {
              email
            });
            setMessage(response.data.message);
        } catch (error) {
            //console.error(error.response); 

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage('You have already signed up for the newsletter.');
                } else {
                    if (retry > 0) {
                        setTimeout(() => {
                            subscribeNewsletter(retry - 1);
                        }, RETRY_DELAY);
                    } else {
                        setMessage('Error: Could not subscribe you to the newsletter. Please try again later or contact support.');
                    }
                }
            } else {
                setMessage('Error: Could not subscribe you to the newsletter. Please try again later or contact support.');
            }
        }
    };

    const handleNewsletterSignup = (event) => {
        event.preventDefault();
        subscribeNewsletter();
    };

    const inputWidthClass = variant === 'sidebar' ? 'w-full' : 'w-46';
    const buttonWidthClass = variant === 'sidebar' ? 'w-full' : 'w-42';

    return (
        <div>
            <form onSubmit={handleNewsletterSignup}>
                <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    required
                    className={`text-black cursor-text text-[0.75rem] font-light py-1.5 px-3.5 mt-4 ${inputWidthClass} border-neutral-200 border-[0.11rem] block`}
                />
                <input
                    type="submit"
                    value="Subscribe"
                    style={{ backgroundColor: '#b5eae7' }} 
                    className={`items-start text-black cursor-pointer text-[0.81rem] font-semibold mt-3 px-8 py-1 uppercase whitespace-pre ${buttonWidthClass} block`}
                />
            </form>
            <div>
                <p className="mb-3.5"></p>
                {message && (
                    <p className="dark:text-white cursor-text text-[0.75rem] font-light py-1.5 px-3.5 w-36 border-neutral-200 border-[0.11rem] block">
                        {message}
                    </p>
                )}
                <p className="mb-3.5"></p>
            </div>
        </div>
    );
};

export default NewsletterSignup;
